import type { ReportConfigurationType } from '@api';
import type { EditReportMailingFormValuesType } from '../../types';

export const mapReportMailingToFormValues = (
  mailing: ReportConfigurationType
): EditReportMailingFormValuesType => {
  const [sendHour, sendMinute] = mailing.sendTime.split(':');
  const options =
    mailing.configurationOptions.kind === 'PERSON'
      ? mailing.configurationOptions
      : null;

  return {
    label: mailing.label,
    isEnabled: mailing.isEnabled,
    recipientMail: options?.recipientMail ?? null,
    scope: options?.scope ?? 'TOUR',
    sendWeekday: mailing.sendWeekday,
    sendHour,
    sendMinute,
    locale: mailing.locale,
    includeRevenue: options?.includeRevenue ?? false,
    profileNote: mailing.profileNote ?? '',
    internalNote: mailing.internalNote ?? '',
  };
};
